import AjandekKonfigurator from './modules/ajandekkonfigurator';

$(function () {
    if (!window.AjandekKonfigurator) {
        window.AjandekKonfigurator = new AjandekKonfigurator();
    }
});
